import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/go-station-2.jpg")